// extracted by mini-css-extract-plugin
export default {"headerclass":"allSubmittedTable_headerclass__aSmHA","headerText":"allSubmittedTable_headerText__zvaUH","rowText":"allSubmittedTable_rowText__ixCF0"};